import * as React from 'react'

const isServerSide = typeof window === 'undefined'

const postpone =
  'unstable_postpone' in React
    ? (React.unstable_postpone as (reason: string) => void)
    : function postpone(e: string) {
        throw new Error(e)
      }

export function useClientOnly() {
  if (isServerSide) postpone('client only')
}
